import { render, staticRenderFns } from "./ValueTreeFieldType1.vue?vue&type=template&id=7972893c&scoped=true"
import script from "./ValueTreeFieldType1.vue?vue&type=script&lang=js"
export * from "./ValueTreeFieldType1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972893c",
  null
  
)

export default component.exports